/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Matrix_OverlineInputs */

const en_cmp_matrix_overline = /** @type {(inputs: Cmp_Matrix_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature matrix`)
};

const id_cmp_matrix_overline = /** @type {(inputs: Cmp_Matrix_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matriks fitur`)
};

/**
* | output |
* | --- |
* | "Feature matrix" |
*
* @param {Cmp_Matrix_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_matrix_overline = /** @type {((inputs?: Cmp_Matrix_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Matrix_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_matrix_overline(inputs)
	return en_cmp_matrix_overline(inputs)
});